// Cloud provider logo icons (official SVGs from Wikimedia Commons)

interface LogoProps {
  height?: number;
  className?: string;
}

export function AwsLogo({ height = 20, className }: LogoProps) {
  return <img src="/images/logos/aws.svg" height={height} style={{ height }} className={className} alt="AWS" />;
}

export function GcpLogo({ height = 20, className }: LogoProps) {
  return <img src="/images/logos/gcp.svg" height={height} style={{ height }} className={className} alt="Google Cloud" />;
}

export function AzureLogo({ height = 20, className }: LogoProps) {
  return <img src="/images/logos/azure.svg" height={height} style={{ height }} className={className} alt="Microsoft Azure" />;
}
